module.exports = __webpack_public_path__ + "img/En.8d21814e.png";